/**
 * Created by yilmaz on 17.06.24.
 * Project: alea-carehome-web
 */

import React, { useState } from 'react';
import { Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import checkIcon from '/assets/images/icons/check.svg';
import modalCloseIcon from '/assets/images/icons/modal-close.svg';
import { TooltipProps } from './Tooltip.tsx';

type ModalProps = TooltipProps & {
  handleSave: (id: string, note: string, risk: string) => void;
  handleModalClose: (id: string) => void;
  handleTabSwitch: (id: string, risk: string) => void;
};

const Modal: React.FC<ModalProps> = ({
  direction,
  verticalDistance,
  placementDistance,
  selection,
  handleSave,
  handleModalClose,
  handleTabSwitch,
  id,
}) => {
  const { t } = useTranslation();
  const selectionClass = selection ? `has-${selection.risk}` : '';
  const [note, setNote] = useState(selection?.note || '');

  return (
    <div
      className={`modal modal-direction-${direction} ${selectionClass}`}
      style={{
        top: verticalDistance,
        transform:
          direction === 'left'
            ? `translateX(-${placementDistance}px)`
            : `translateX(${placementDistance}px)`,
        left: direction === 'left' ? 0 : 'auto',
        right: direction === 'right' ? 0 : 'auto',
      }}
    >
      <div className="modal-tabs">
        <button
          className="risk-tab"
          onClick={() => handleTabSwitch(id, 'Threat')}
        >
          {t('bedsoresRisk')}
        </button>
        <button
          className="wound-tab"
          onClick={() => handleTabSwitch(id, 'Wound')}
        >
          {t('wound')}
        </button>
      </div>
      <div className="modal-body">
        <input
          type="text"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Notes"
        />
      </div>
      <div className="modal-footer">
        <button
          className={`save ${selection ? '' : 'disabled'}`}
          disabled={!selection}
          onClick={() =>
            handleSave(
              id,
              note!,
              selection && selection?.risk ? selection.risk : 'risk'
            )
          }
        >
          <Image src={checkIcon} alt="Save" />
        </button>
        <button className="close" onClick={() => handleModalClose(id)}>
          <Image src={modalCloseIcon} alt="Close Window" />
        </button>
      </div>
    </div>
  );
};

export default Modal;
